import { config } from 'api';
import errorHandler from 'utils/errorHandler';

const PLACED_ORDER = `${config.apiBasePath}/orders/summary/lastModified`;
const CHECKOUT_ADS_URL = `${config.apiBasePath}/customer/checkout/confirmation/scribe`;
const CHECKOUT_ANALYTICS_URL = `${config.apiBasePath}/customer/checkout/confirmation/analytics`;

export const CHECKOUT_ADS = 'CHECKOUT_ADS';
export const CHECKOUT_PLACED_ORDER = 'CHECKOUT_PLACED_ORDER';
export const CHECKOUT_ANALYTICS = 'CHECKOUT_ANALYTICS';

export function receivePlacedOrder(data) {
  return {
    type: CHECKOUT_PLACED_ORDER,
    data,
  };
}

export function getCheckoutPlacedOrder() {
  return (dispatch, getState, { network }) => network.get(PLACED_ORDER)
    .then(data => dispatch(receivePlacedOrder(data)))
    .catch(errorHandler);
}

export function receiveAds(data) {
  return {
    type: CHECKOUT_ADS,
    scribeContent: data,
  };
}

export function getCheckoutAds() {
  return (dispatch, getState, { network }) => network.get(CHECKOUT_ADS_URL)
    .then(data => dispatch(receiveAds(data)))
    .catch(errorHandler);
}

export function receiveAnalytics(data) {
  return {
    type: CHECKOUT_ANALYTICS,
    analytics: data,
  };
}

export function getCheckoutAnalytics() {
  return (dispatch, getState, { network }) => network.get(CHECKOUT_ANALYTICS_URL)
    .then(data => dispatch(receiveAnalytics(data)))
    .catch(errorHandler);
}
